<template>
 
  <div class="hero-image container-fluid">

    <div class="dropdown ">
      <img src="../../assets/2023/menu.svg" class="dropbtn">

    <div class="dropdown-content ">
      <a href="#guests"><div>Guests</div></a>
        <a href="#"><div>Green 4D</div></a>
        <a href="#"><div>Transforma</div></a>
        <a href="#partners"><div>Partners</div></a>
        <a href="https://flash-forward-co-za.zoom.us/meeting/register/tJYtd-Grqj4tHd09gzf4spf--NNF_Pd2HC8X">
          <div>Register</div>
        </a>
    </div>
  </div>  
   
    <div class="__flex hn5757 ">
      <div class=""><a href="#guests">Guests</a></div>
      <div class=""> <a href="#">Green 4D</a></div>
      <div>  <a href="#">Transforma</a></div>
      <div><a href="#partners">Partners</a></div>
      <div><a href="https://flash-forward-co-za.zoom.us/meeting/register/tJYtd-Grqj4tHd09gzf4spf--NNF_Pd2HC8X">Register</a></div>
        

    </div>

    <div class="Hvdb3xz">
        <img src="../../assets/2023/boma2023-logo.svg" alt="">
    </div>
    <div class="cDret36 __mg-auto">
        <a href="https://flash-forward-co-za.zoom.us/meeting/register/tJYtd-Grqj4tHd09gzf4spf--NNF_Pd2HC8X"><button>REGISTER NOW</button></a>
    </div>
    <!-- <div class=" img__fill ">
                <img src="../../assets/2023/rings_trans.svg" alt="">
    
            </div>     -->
   </div>
   
   
</template>

<script>
/* eslint-disable */
export default {
name:'Hero'
}
</script>

<style>
.hn5757 a{text-decoration: none !important;color:#FFF;width:100%}
.me4u7{color:white;position:relative;display: inline-block;}
.Zgdbg6w{background:#FFF;color:#000;font-size:12px;position: absolute;width:90%;display: none;}
.me4u7:hover .Zgdbg6w{display:block!important}
.cDret36{position: relative;top:10em;max-width:297px;}
.cDret36 button{background: #00DA7A;height:44px;width:100%;border:0;border-radius: 10em;color: #17704F;font-size: 20px;font-weight:600
}
.Hvdb3xz img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.Hvdb3xz{ max-width: 786px;height: 233px; position:relative;top:100px;margin: auto;padding: 2em;}
.hn5757{width: 50%;margin: auto;position: relative;top:2em}
.hn5757 div{margin: auto;color:#FFF;font-size:12px;padding: 0.7em;}
.hn5757 div:hover
{background-color: #00DA7A;
    color: #000;border-radius: 10em;padding: 0.7em;
}

 .hero-image {
      position: relative;
      background-image: url('../../assets/2023/hero-image-home.png');
      background-size: cover;
      background-position: center;
      height: 700px; /* Adjust the height as per your needs */
      width:100%
    }

  
/*mobile-tablet */
@media (max-width: 768px) { 
  .dropdown{display: block !important;;}
.hn5757{display: none;}
.dropdown:hover .dropdown-content {
  display: block !important;;
}
.overlay-content {
    height: 100%;
    width: 100%;
    position: fixed;
    display: none;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: #000;
    background-color: rgba(0,0,0,.9);
    overflow-x: hidden;
    transition: .5s;
}
#nav_toggler {
    display: block;
    width: 50px;
    height: 50px;
    margin-top: 50px;
    background-color: transparent;
    color: #fff;
    font-size: 2.2em;
    outline: none;
    border: none;
}
}
@media (max-width: 576px) { 
  .hero-image {height:400px!important}
  .Hvdb3xz{ max-width: 786px;height: 233px; position:relative;top:0px;}
  .cDret36{position: relative;top:0em;max-width:197px;}
  .cDret36 button{height:34px;width:100%;font-size:15px
}
}

@media (min-width: 576px) { 
}

@media (min-width: 768px) {   
  .dropdown,.dropdown-content {
  display: none !important;;
}

}

@media (min-width: 992px) { 
 

}
</style>
